import { Box, FormControl, FormHelperText, Tooltip } from '@mui/material';
import { isEmpty } from 'lodash';
import React from 'react';
import { FBInputProps } from '../../types/common';
import FBTextField from '../inputs/FBTextField';

const FBInput: React.FunctionComponent<FBInputProps> = ({
  error,
  helperText = '',
  children,
  showContext,
  contextLabel,
  disabled,
  name,
  tooltip = '',
  fullWidth = true,
}) => (
  <Tooltip title={tooltip} placement="bottom-start">
    <FormControl error={error} fullWidth={fullWidth}>
      {children}

      {!isEmpty(helperText) && (
        <FormHelperText>
          <Box color={error ? 'error.main' : 'primary.main'}>
            {helperText}
          </Box>
        </FormHelperText>
      )}

      {showContext && (
        <Box mt={3}>
          <FBTextField
            label={contextLabel}
            disabled={disabled}
            name={`input-context-${name}`}
          />
        </Box>
      )}
    </FormControl>
  </Tooltip>
);

export default FBInput;
